import { render } from "./FpTabs.vue?vue&type=template&id=35ae9eb8&scoped=true"
import script from "./FpTabs.vue?vue&type=script&lang=js"
export * from "./FpTabs.vue?vue&type=script&lang=js"

import "./FpTabs.vue?vue&type=style&index=0&id=35ae9eb8&scoped=true&lang=scss"

import exportComponent from "/home/forge/olyo.io/app-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35ae9eb8"]])

export default __exports__